import { useSelector } from 'react-redux'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../../../utils/authorization'
import { COMPANY_TYPES } from '../../../../../utils/common'
import useCheckIsCompanyType from '../useCheckIsCompanyType'
import { Content } from './Content'

export const CreditRiskScore = (props) => {
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  const isHidden = useCheckIsCompanyType([
    COMPANY_TYPES.FUNDS,
    COMPANY_TYPES.INSURANCE,
    COMPANY_TYPES.NON_BANK,
    COMPANY_TYPES.BANK,
    COMPANY_TYPES.SECURITIES,
  ])

  return (
    AUTHORIZATION_API.companyAnalysis.creditRiskScore[userType.userTypeId] ===
      AUTHORIZATION_TYPE.ALLOW &&
    !isHidden && <Content {...props} />
  )
}
